import React, { Component } from 'react';
import { connect } from 'react-redux'
import RequisitionTable from '../../layouts/requisition_list/RequisitionTable'
import '../../assets/css/requisition.css'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import PropTypes from 'prop-types'
import { withStyles, Button } from '@material-ui/core';
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { 
    getRequisitionList,
    updateRequisitionStatus
} from '../../actions/RequisitionActions'
import {
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_ADMIN_CREATE_JOB
} from '../../utils/routes'
import {
    NavLink,
    Redirect
} from 'react-router-dom'
import InformationDialog from '../../components/Dialog/InformationDialog'
import {
    logout
} from '../../actions/LoginAction'
import {
    withCookies
} from 'react-cookie'


class RequisitionList extends Component {

    constructor() {
        super();
        this.state = {
          page_index: 1,
          open: false,
        }
    }

    componentWillMount() {
        this.props.getRequisitionList(this.state.page_index, this.props.cookies.cookies.jwt)
    }

    render(){

        const { classes } = this.props
        
        if(this.props.requisition_list.unauthorize) {

            return(
                 <Redirect from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_LOGIN}/>
             )

        }else {
            
            return (
                <div className={classes.main}>

                    <InformationDialog
                        open={this.state.open}
                        handleClose={this.handleClose}
                        handleLogout={this.handleLogout}
                    />
    
                    <div className="Content">
    
                        <div className="CvBtn">
                            <NavLink disabled={true} from={ROUTE_REQUISITION_LIST} to={ROUTE_REQUISITION_LIST}>
                                <Button  variant="outlined" disabled={true} className={classes.nav_button} color="secondary">
                                    View Requisitions
                                </Button>
                            </NavLink>
                            <NavLink  from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_JOB}>
                                <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                    View Jobs
                                </Button>
                            </NavLink>
                            <NavLink  from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_CREATE_JOB}>
                                <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                    Create Job
                                </Button>
                            </NavLink>
                            <NavLink from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_CV}>
                                <Button variant="outlined" className={classes.nav_button} color="secondary">
                                    View CVs
                                </Button>
                            </NavLink>
                            {/* <NavLink from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_CV}> */}
                                <Button 
                                    onClick={() => this.onLogout()}
                                    variant="outlined" 
                                    className={classes.nav_button} 
                                    color="secondary">
                                    Logout
                                </Button>
                            {/* </NavLink> */}
                        </div>
                       
                        <RequisitionTable
                            tableHeadColor = "primary"
                            // tableHead = {["Title", "Department","Designation", "Type", "Contract","Status", "Target Date", "ReceivedDate", "Accept", "Decline", "Detail"]}
                            tableHead = {["Title", "Department", "Confidential", "Status", "Target Date", "ReceivedDate", "Accept", "Decline", "Detail"]}
                            tableData = {this.props.requisition_list.list}
                            onApprove = {this.handleOnApprve}
                            onDecline = {this.handleOnDecline}            
                        />

                        <GridContainer>

                            <GridItem xs={12} sm={12} md={6}>
                                <Button
                                    className={classes.next_button}
                                    color="secondary"
                                    variant="contained"
                                    disabled={this.state.page_index === 1} 
                                    onClick={() => this.handlePrev()}>
                                    Prev Page
                                </Button>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={6}>
                                <div className="PageButton">
                                    <Button 
                                        className={classes.next_button}
                                        disabled={this.props.requisition_list.list.length < 20}
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => this.handleNext()}>
                                        Next Page
                                    </Button>
                                </div>
                            </GridItem>

                        </GridContainer>

                    </div>
                </div>
            );

        }
        
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
      //  this.props.history.push(ROUTE_ADMIN_LOGIN);

    }

    handleOnApprve = (item) => {
        this.props.updateRequisitionStatus({item, status: "accepted", page_index: this.state.page_index})
    }

    handleOnDecline = (item) => {
        this.props.updateRequisitionStatus({item, status: "declined", page_index: this.state.page_index})
    }

    handleNext = () => {

        this.setState( state => ({
            page_index: state.page_index + 1
        }))
        this.props.getRequisitionList(this.state.page_index +1,  this.props.cookies.cookies.jwt)
    }

    handlePrev = () => {

        if(this.state.page_index > 1) {
            this.setState( state => ({
                page_index: state.page_index - 1
            }))
        }
        this.props.getRequisitionList(this.state.page_index - 1,  this.props.cookies.cookies.jwt)
    }

}

RequisitionList.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch) => ({
    getRequisitionList: (page_index, jwt) => {
      dispatch(
        getRequisitionList(page_index, jwt)
      )
    },
    updateRequisitionStatus: (prop) => {
        dispatch(
            updateRequisitionStatus(prop)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
  })
  
const mapStateToProps = (state, ownProps) => ({
    requisition_list: state.requisition,
    ownProps: ownProps.cookies
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(requisitionStyle)(withCookies(RequisitionList)));